function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import HeroPdpTop from './HeroPdpTop';
import TilePdpTop from './TilePdpTop';
import classNames from '../../utils/classNames';

var Pdp = /*#__PURE__*/function (_PureComponent) {
  _inherits(Pdp, _PureComponent);

  var _super = _createSuper(Pdp);

  function Pdp() {
    _classCallCheck(this, Pdp);

    return _super.apply(this, arguments);
  }

  _createClass(Pdp, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accessibilityFeatures = _this$props.accessibilityFeatures,
          addons = _this$props.addons,
          backgroundImage = _this$props.backgroundImage,
          className = _this$props.className,
          cta = _this$props.cta,
          friendsWhoPlay = _this$props.friendsWhoPlay,
          gameInfo = _this$props.gameInfo,
          gameOverview = _this$props.gameOverview,
          gameRatings = _this$props.gameRatings,
          legalText = _this$props.legalText,
          starRating = _this$props.starRating,
          title = _this$props.title,
          top8 = _this$props.top8,
          type = _this$props.type,
          versionSelector = _this$props.versionSelector;
      var TopComponent = type === 'hero' ? HeroPdpTop : TilePdpTop;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-stack-left', className)
      }, /*#__PURE__*/React.createElement(TopComponent, {
        title: title,
        backgroundImage: backgroundImage,
        cta: cta,
        gameRatings: gameRatings,
        top8: top8
      }), versionSelector && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, versionSelector), addons && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, addons), starRating && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, starRating), friendsWhoPlay && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, friendsWhoPlay), accessibilityFeatures && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, accessibilityFeatures), gameOverview && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, gameOverview), gameInfo && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, gameInfo), legalText && /*#__PURE__*/React.createElement("div", {
        className: "psw-m-t-10 psw-fill-x"
      }, legalText), /*#__PURE__*/React.createElement("div", {
        className: "psw-l-line-left psw-m-t-11"
      }));
    }
  }]);

  return Pdp;
}(PureComponent);

Pdp.defaultProps = {
  accessibilityFeatures: null,
  addons: null,
  backgroundImage: null,
  className: '',
  cta: null,
  friendsWhoPlay: null,
  gameInfo: null,
  gameOverview: null,
  gameRatings: null,
  legalText: null,
  starRating: null,
  title: null,
  top8: null,
  type: 'tile',
  versionSelector: null
};
Pdp.propTypes = {
  accessibilityFeatures: PropTypes.node,
  addons: PropTypes.node,
  backgroundImage: PropTypes.node,
  className: PropTypes.string,
  cta: PropTypes.node,
  friendsWhoPlay: PropTypes.node,
  gameInfo: PropTypes.node,
  gameOverview: PropTypes.node,
  gameRatings: PropTypes.node,
  legalText: PropTypes.node,
  starRating: PropTypes.node,
  title: PropTypes.node,
  top8: PropTypes.node,
  type: PropTypes.oneOf(['tile', 'hero']),
  versionSelector: PropTypes.node
};
export default Pdp;